import React,{ Component } from "react";
import {Row, Alert, Col, Spinner, Button, Jumbotron, Card, CardHeader, CardBody, CardFooter, Collapse,
    Modal,ModalHeader,ModalBody, ModalFooter } from "reactstrap";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { withRouter, Link } from "react-router-dom";
import AgentTabs from "./ReportComponents/AgentTabs"
import UsageTab from "./ReportComponents/UsageTab"
import UserTable from "./ReportComponents/UserTable"
import DomainTable from "./ReportComponents/DomainTable"
import KasmTable from "./ReportComponents/KasmTable"
import moment from "moment";
import { getLogins, getTotalUsers, getErrors, getCreatedKasms, getCurrentKasms,  getCurrentUsers, getDomainUsage,
    getAgent, getActiveUsers, getAvgKasm, getDestroyedKasms, getImageUsage, getUserUsage, getAlert, getKasms,setUserUsagePageInfo,setDomainUsagePageInfo } from "../../../actions/actionReporting"
import { getKasm } from "../../../actions/actionKasm";
import Proptypes from "prop-types";
import DateTimePicker from 'react-datetime-picker';
import Select from "react-select";

var intID = 0;

class ReportDashboard extends Component{
    constructor(props) {
        super(props);
        this.state = {
            alert: true,
            endDate: new Date(),
            startDate: new Date(Date.now() - 60000 * 60),
            resolution: 10,
            timePeriod: 1440,
            customModal: false,
            polling: 0,
            collapseAgents: true,
            collapseUser: true,
            collapseDomain: true,
            collapseUsage: true,
            timeData: {}
        };

        this.changeStartDate = this.changeStartDate.bind(this);
        this.changeEndDate = this.changeEndDate.bind(this);
        this.getReports = this.getReports.bind(this);
        this.changeResolution = this.changeResolution.bind(this);
        this.changeTimePeriod = this.changeTimePeriod.bind(this);
        this.toggleCustomModal = this.toggleCustomModal.bind(this);
        this.startPolling = this.startPolling.bind(this);
        this.changePoll = this.changePoll.bind(this);
        this.toggleAgents = this.toggleAgents.bind(this);
        this.toggleUser = this.toggleUser.bind(this);
        this.toggleUsage = this.toggleUsage.bind(this);
        this.toggleDomain = this.toggleDomain.bind(this);
        this.getTimeData = this.getTimeData.bind(this);
    }


    toggleAgents() {
        if (!this.state.collapseAgents) {
            this.props.getAgent(this.state.timeData);
        }

        this.setState({collapseAgents: !this.state.collapseAgents}, () => {
            window.localStorage.setItem('collapseAgents', this.state.collapseAgents);
        });
    }

    toggleUser() {
        if (!this.state.collapseUser) {
            this.props.getUserUsage(this.state.timeData);
        }

        this.setState({collapseUser: !this.state.collapseUser}, () => {
            window.localStorage.setItem('collapseUser', this.state.collapseUser);
        });
    }

    toggleDomain() {
        if (!this.state.collapseDomain) {
            this.props.getDomainUsage(this.state.timeData);
        }

        this.setState({collapseDomain: !this.state.collapseDomain}, () => {
            window.localStorage.setItem('collapseDomain', this.state.collapseDomain);
        });
    }

    toggleUsage() {
        if (!this.state.collapseUsage) {
            let time_data = this.getTimeData();
            this.props.getCurrentKasms(this.state.timeData);
            this.props.getCurrentUsers(this.state.timeData);
            this.props.getKasms(this.state.timeData);
            this.props.getImageUsage(this.state.timeData);
            this.props.getLogins(this.state.timeData);
            this.props.getActiveUsers(this.state.timeData);
            this.props.getAvgKasm(this.state.timeData);
            this.props.getCreatedKasms(this.state.timeData);
            this.props.getErrors(this.state.timeData);
            this.props.getkasm();
        }

        this.setState({collapseUsage: !this.state.collapseUsage}, () => {
            window.localStorage.setItem('collapseUsage', this.state.collapseUsage);
        });
    }

    toggleCustomModal() {
        this.setState({customModal: !this.state.customModal});
    }

    changeResolution(res) {
        this.setState({resolution: res.value});
    }

    changeTimePeriod(res) {
        if (res.value === 1) {
            this.setState({timePeriod: res.value});
            this.toggleCustomModal();
        } else {
            // set state is asynchronous use call back function to update reports after change
            this.setState(() => {return {timePeriod: res.value};}, () => {this.getReports()});
        }
    }

    changePoll(res) {
        this.setState({polling: res.value});
    }

    changeStartDate(startDate) {
        this.setState({startDate: startDate});
    }

    changeEndDate(enddate) {
        this.setState({endDate: enddate});
    }

    getTimeData() {
        const {startDate, endDate, polling, timePeriod} = this.state;
        let time_data = {};
        if (timePeriod === 1) {
            let start_date = moment(startDate).utc().format("YYYYMMDD HH:mm");
            let end_date = moment(endDate).utc().format("YYYYMMDD HH:mm");
            let res;
            let time = moment.utc(endDate).diff(moment.utc(startDate));
            time = (time /1000) /60;
            //set a default resolution
            if (time < 61) {
                res = 1;
            } else if (time < 361) {
                res = 10;
            } else if (time < 4321) {
                res = 60
            } else
                res = 1440;
            time_data = {
                start_date: start_date,
                end_date: end_date,
                resolution: res
            };
            if (polling !== 0) {
                this.startPolling(polling)
            }
        } else {
            //Setting default options for time period selections
            if (timePeriod === 60) {
                time_data = {
                    delta: 60,
                    resolution: 1
                };
            } else if (timePeriod === 1440) {
                time_data = {
                    delta: 1440,
                    resolution: 60
                };
            } else if (timePeriod === 10080) {
                time_data = {
                    delta: 10080,
                    resolution: 1440
                };
            } else if (timePeriod === 0) {
                time_data = {
                    delta: 60,
                    resolution: 1
                };
                this.startPolling(300);
            }
            window.localStorage.setItem('report_delta', this.state.timePeriod);
        }

        this.setState({timeData: time_data});
        return time_data;
    }

    getReports(){
       let timeData = this.getTimeData();

        if (this.state.collapseUser) {
            this.props.getUserUsage(timeData);
        }

        if (this.state.collapseDomain) {
            this.props.getDomainUsage(timeData);
        }

        if (this.state.collapseAgents) {
            this.props.getAgent(timeData);
        }

        if (this.state.collapseUsage) {
            this.props.getCurrentKasms(timeData);
            this.props.getCurrentUsers(timeData);
            this.props.getKasms(timeData);
            this.props.getImageUsage(timeData);
            this.props.getLogins(timeData);
            this.props.getActiveUsers(timeData);
            this.props.getAvgKasm(timeData);
            this.props.getCreatedKasms(timeData);
            this.props.getErrors(timeData);
            this.props.getkasm();
        }
    }

    startPolling(seconds) {
        clearInterval(intID);
        intID = setInterval(this.getReports, seconds * 1000);
    }

    componentDidMount(){
        this.getReports();
        this.props.getAlert();
    }

    componentWillMount() {
        this.setState({
           collapseAgents: window.localStorage.getItem('collapseAgents') ? window.localStorage.getItem('collapseAgents') === 'true' : true,
           collapseUser: window.localStorage.getItem('collapseUser') ? window.localStorage.getItem('collapseUser') === 'true' : true,
            collapseDomain: window.localStorage.getItem('collapseDomain') ? window.localStorage.getItem('collapseDomain') === 'true' : true,
           collapseUsage: window.localStorage.getItem('collapseUsage') ? window.localStorage.getItem('collapseUsage') === 'true' : true
        });
        window.localStorage.getItem('report_delta') &&
        this.setState({ timePeriod: JSON.parse(window.localStorage.getItem('report_delta'))});
    }

    componentWillUnmount() {
        clearInterval(intID);
    }

    render(){
        const {logins_by_hour, active_users, kasms, get_alert} = this.props;
        const {images, agents, users, domains, current_users, current_kasms } = this.props;
        const {created_kasms, avg_kasm_duration, get_errors} = this.props;
        const {getLoginsLoading, getActiveUsersLoading, getAgentsLoading, getKasmsLoading, getImageUseLoading } = this.props;
        const {getTotalUsersLoading, getKasmLengthLoading, getCurrentUsersLoading , getErrorLoading, getCurrentKasmLoading } = this.props;
        const { getKasmUseLoading } = this.props;
        const { getDomainUseLoading } = this.props;

        const timeOptions = [
            {value:0, label:'Real-Time'},
            {value:60, label:'Last Hour'},
            {value:1440, label:'Last Day'},
            {value:10080, label:'Last Week'},
            {value:1, label:'Custom'}
        ];
        const pollOptions = [
            {value:0, label:'Off'},
            {value:60, label:'Every Minute'},
            {value:(60 * 5), label:'Five Minutes'},
            {value:(60 * 10), label:'Ten Minutes'},
        ];

        return(
            <div className="reporting profile-page">
                <Row className={"bg-white pb-2"}>
                    <Col md={{ size: 10, order: 3, offset: 1 }}>
                        <Row>
                                <Col sm={5} md={3} xl={3}>
                                    <small className="text-muted">Time Period</small><br />
                                    <Select
                                        clearable={false}
                                        autoFocus
                                        value={this.state.timePeriod}
                                        options={timeOptions}
                                        onChange={this.changeTimePeriod}
                                    />
                                </Col>
                        </Row>
                    </Col>
                </Row>

                { get_alert && get_alert.alert &&
                    <Row className="pt-3">
                        <Col sm={{ size: 10, order: 3, offset: 1 }}>
                            <Alert color="danger" isOpen={this.state.alert} toggle={() => (this.setState({alert: !this.state.alert}))}>
                                <strong>{get_alert.alert_title}</strong> <br />
                                <hr />
                                {get_alert.alert}
                            </Alert>
                        </Col>
                    </Row>}

                <Row className={"pt-2"}>
                    <Col sm={12} md={{ size: 10, offset: 1 }}>
                        <Card>
                            <a onClick={this.toggleUsage}>
                                <CardHeader>
                                    <strong>Usage</strong>
                                    <span className="float-right">
                                {this.state.collapseUsage ? <i className="fa fa-chevron-down" /> : <i className="fa fa-chevron-up" />}
                            </span>
                                </CardHeader>
                            </a>
                            <Collapse isOpen={this.state.collapseUsage}>
                            <UsageTab
                                active_users={active_users}
                                logins_by_hour={logins_by_hour}
                                average_kasm_duration={avg_kasm_duration}
                                created_kasms={created_kasms}
                                errors={get_errors}
                                images={images}
                                kasms={kasms}
                                start_date={this.state.startDate}
                                end_date={this.state.endDate}
                                delta={this.state.timePeriod}
                                selectOpen={this.state.customModal}
                                current_kasms={current_kasms}
                                current_users={current_users}
                                getLoginsLoading={getLoginsLoading}
                                getActiveUsersLoading={getActiveUsersLoading}
                                getTotalUsersLoading={getTotalUsersLoading}
                                getKasmLengthLoading={getKasmLengthLoading}
                                getErrorLoading={getErrorLoading}
                                getKasmsLoading={getKasmsLoading}
                                getImageUseLoading={getImageUseLoading}
                                getCurrentKasmLoading={getCurrentKasmLoading}
                                getCurrentUsersLoading={getCurrentUsersLoading}
                                live_kasms={this.props.live_kasms}
                                current_time={this.props.current_time}
                            />
                            </Collapse>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={{ size: 10, offset: 1 }}>
                        <Card>
                            <a onClick={this.toggleAgents}>
                                <CardHeader>
                                    <strong>Agents</strong>
                                    <span className="float-right">
                                        {this.state.collapseAgents ? <i className="fa fa-chevron-down" /> : <i className="fa fa-chevron-up" />}
                                    </span>
                                </CardHeader>
                            </a>
                            <Collapse isOpen={this.state.collapseAgents}>
                                <CardBody>
                                    {getAgentsLoading ?
                                        <span className={"agentcard"}><Spinner color="primary" /></span>
                                        :
                                        agents ? <AgentTabs agents={agents} timeData={this.getTimeData}/> : 'No Data'
                                    }
                                </CardBody>
                            </Collapse>
                        </Card>
                    </Col>
                </Row>

                {getKasmUseLoading ?
                    <Row>
                        <Col sm={12} md={{ size: 10, offset: 1 }}>
                            <Card>
                                <CardHeader>
                                    <strong>User Usage </strong>
                                </CardHeader>
                                <CardBody>
                                    <center><Spinner color="primary" /></center>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col sm={12} md={{ size: 10, offset: 1 }}>
                            <Card>
                                <a onClick={this.toggleUser}>
                                    <CardHeader>
                                        <strong>User Usage </strong>
                                        <span className="float-right">
                                            {this.state.collapseUser ? <i className="fa fa-chevron-down" /> : <i className="fa fa-chevron-up" />}
                                        </span>
                                    </CardHeader>
                                </a>
                                <Collapse isOpen={this.state.collapseUser}>
                                    <CardBody className={`${users && users.data ? "p-0" : "no-data"}`}>
                                        {users && users.data ? <UserTable users={users} setPageInfo = {this.props.setUerUsagePageInfo} pageSize = {this.props.userUsagePages.pageSize} pageNo = {this.props.userUsagePages.pageNo} /> : "No Data for Time Period"}
                                    </CardBody>
                                </Collapse>
                            </Card>
                        </Col>
                    </Row>
                }

                {getDomainUseLoading ?
                    <Row>
                        <Col sm={12} md={{ size: 10, offset: 1 }}>
                            <Card>
                                <CardHeader>
                                    <strong>Domain Usage</strong>
                                </CardHeader>
                                <CardBody>
                                    <center><Spinner color="primary" /></center>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col sm={12} md={{ size: 10, offset: 1 }}>
                            <Card>
                                <a onClick={this.toggleDomain}>
                                    <CardHeader>
                                        <strong>Domain Usage</strong>
                                        <span className="float-right">
                                            {this.state.collapseDomain ? <i className="fa fa-chevron-down" /> : <i className="fa fa-chevron-up" />}
                                        </span>
                                    </CardHeader>
                                </a>
                                <Collapse isOpen={this.state.collapseDomain}>
                                    <CardBody className={`${domains && domains.data ? "p-0" : "no-data"}`}>
                                        {domains && domains.data ? <DomainTable domains={domains}
                                        setPageInfo = {this.props.setDomainUsagePageInfo}
                                        pageSize = {this.props.domainUsagePages.pageSize} pageNo = {this.props.domainUsagePages.pageNo}
                                        /> : "No Data for Time Period"}
                                    </CardBody>
                                </Collapse>
                            </Card>
                        </Col>
                    </Row>
                }


                <Modal zIndex={999999} isOpen={this.state.customModal} toggle={this.toggleCustomModal} className="user-modal" >
                    <ModalHeader toggle={this.toggleCustomModal}>
                        Custom Time Settings
                    </ModalHeader>
                    <ModalBody>
                        <Col sm={10}>
                            <small className="text-muted">Start Date</small><br />
                            <DateTimePicker
                                clearIcon={null}
                                required={true}
                                onChange={this.changeStartDate}
                                value={this.state.startDate}
                            />
                        </Col>
                        <Col sm={10}>
                            <small className="text-muted">End Date</small><br />
                            <DateTimePicker
                                clearIcon={null}
                                required={true}
                                onChange={this.changeEndDate}
                                value={this.state.endDate}
                            />
                        </Col>
                        <Col sm={10} >
                            <small className="text-muted">Auto-Refresh</small><br />
                            <Select
                                clearable={false}
                                autoFocus
                                value={this.state.polling}
                                options={pollOptions}
                                onChange={this.changePoll}
                            />
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.toggleCustomModal} 
                                size="sm" 
                                color="basic" 
                                className="cancel-button"
                        >    
                            Close
                        </Button>
                        <Button size="sm"
                                color="primary"
                                onClick={() => {this.getReports(); this.toggleCustomModal();}}
                                className="submit-button"
                        >
                            Update
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

ReportDashboard.propTypes = {
    active_users: Proptypes.object,
    logins_by_hour: Proptypes.object,
    agents: Proptypes.object,
    users: Proptypes.object,
    domains: Proptypes.object,
    images: Proptypes.object,
    total_users: Proptypes.number,
    created_kasms: Proptypes.number,
    average_kasm_duration: Proptypes.string,
    errors_reported: Proptypes.number,
};

let DashboardWithRouter = withRouter(ReportDashboard);


export default connect(state =>
        ({
            active_users: state.reporting.active_users,
            agents: state.reporting.agents,
            users: state.reporting.users,
            domains: state.reporting.domains,
            images: state.reporting.images,
            total_users: state.reporting.total_users,
            average_kasm_duration: state.reporting.average_kasm_duration,
            errors_reported: state.reporting.errors_reported,
            logins_by_hour: state.reporting.logins_by_hour,
            avg_kasm_duration: state.reporting.avg_kasm_duration,
            destroyed_kasms: state.reporting.destroyed_kasms,
            created_kasms: state.reporting.created_kasms,
            get_errors: state.reporting.get_errors,
            get_alert: state.reporting.get_alert,
            getLoginsLoading: state.reporting.getLoginsLoading,
            getActiveUsersLoading: state.reporting.getActiveUsersLoading,
            getAgentsLoading: state.reporting.getAgentsLoading,
            getTotalUsersLoading: state.reporting.getTotalUsersLoading,
            getKasmLengthLoading: state.reporting.getKasmLengthLoading,
            getDestroyedKasmsLoading: state.reporting.getDestroyedKasmsLoading,
            getCreatedKasmsLoading: state.reporting.getCreatedKasmsLoading,
            getReportLoading: state.reporting.getReportLoading,
            getErrorLoading: state.reporting.getErrorLoading,
            getImageUseLoading: state.reporting.getImageUseLoading,
            getKasmsLoading: state.reporting.getKasmsLoading,
            getKasmUseLoading: state.reporting.getKasmUseLoading,
            getDomainUseLoading: state.reporting.getDomainUseLoading,
            getCurrentUsersLoading: state.reporting.getCurrentUsersLoading,
            getCurrentKasmLoading: state.reporting.getCurrentKasmLoading,
            kasms: state.reporting.kasms,
            current_kasms: state.reporting.current_kasms,
            current_users: state.reporting.current_users,
            live_kasms: state.kasms.kasms,
            current_time: state.kasms.current_time || null,
            userUsagePages : {pageSize : state.reporting.userUsagePageSize, pageNo : state.reporting.userUsagePageNo},
            domainUsagePages : {pageSize : state.reporting.domainUsagePageSize, pageNo : state.reporting.domainUsagePageNo},
        }),
    dispatch =>
        ({
            getAgent: (data) => dispatch(getAgent(data)),
            getActiveUsers: (data) => dispatch(getActiveUsers(data)),
            getLogins: (data) => dispatch(getLogins(data)),
            getAvgKasm: (data) => dispatch(getAvgKasm(data)),
            getCreatedKasms: (data) => dispatch(getCreatedKasms(data)),
            getErrors: (data) => dispatch(getErrors(data)),
            getImageUsage: (data) => dispatch(getImageUsage(data)),
            getUserUsage: (data) => dispatch(getUserUsage(data)),
            getAlert: (data) => dispatch(getAlert(data)),
            getKasms: (data) => dispatch(getKasms(data)),
            getCurrentUsers: (data) => dispatch(getCurrentUsers(data)),
            getCurrentKasms: (data) => dispatch(getCurrentKasms(data)),
            getkasm: () => dispatch(getKasm()),
            getDomainUsage: (data) => dispatch(getDomainUsage(data)),
            setUerUsagePageInfo : (data)=> dispatch(setUserUsagePageInfo(data)),
            setDomainUsagePageInfo : (data)=> dispatch(setDomainUsagePageInfo(data)),
        }))(DashboardWithRouter);


// WEBPACK FOOTER //
// ./src/views/Reporting/ReportDashboard/ReportDashboard.js